import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconDiscord = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#Icon_Discord_svg__a)"><path fill="currentColor" d="M54.18 11.628a52.8 52.8 0 0 0-13.028-4.044.2.2 0 0 0-.208.1c-.564 1-1.188 2.308-1.624 3.332a48.8 48.8 0 0 0-14.632 0 32 32 0 0 0-1.648-3.332.2.2 0 0 0-.208-.1c-4.5.776-8.88 2.136-13.028 4.044a.16.16 0 0 0-.084.072C1.424 24.096-.852 36.188.264 48.128a.23.23 0 0 0 .084.148 53.2 53.2 0 0 0 15.98 8.08.2.2 0 0 0 .224-.076 38 38 0 0 0 3.272-5.316.2.2 0 0 0-.04-.236l-.072-.044a36 36 0 0 1-4.992-2.38.2.2 0 0 1-.08-.264l.06-.076q.509-.38.992-.78a.2.2 0 0 1 .204-.028c10.476 4.784 21.816 4.784 32.164 0a.2.2 0 0 1 .212.028q.484.4.992.78a.2.2 0 0 1-.016.34 32 32 0 0 1-4.996 2.376.2.2 0 0 0-.108.284c.96 1.86 2.06 3.636 3.268 5.316a.2.2 0 0 0 .224.076 52.8 52.8 0 0 0 16.004-8.08.2.2 0 0 0 .084-.148c1.336-13.804-2.236-25.796-9.464-36.424a.12.12 0 0 0-.08-.076M21.388 40.856c-3.156 0-5.752-2.896-5.752-6.448s2.548-6.452 5.752-6.452c3.228 0 5.8 2.92 5.752 6.452 0 3.552-2.548 6.448-5.752 6.448m21.264 0c-3.152 0-5.752-2.896-5.752-6.448s2.548-6.452 5.752-6.452c3.228 0 5.804 2.92 5.752 6.452 0 3.552-2.524 6.448-5.752 6.448" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_Discord_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconDiscord.displayName = 'IconDiscord';